import React, { useState } from "react";
import {
    Icon,
    Header,
} from "semantic-ui-react";
import "./index.scss";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { ActivityPopup } from "shared/forms/NewActivity";
import CallLogWrapper from "./CallLogWrapper";
import { useDispatch, useSelector } from 'react-redux';
import timelineActions from "actions/timeline";
import RestrictedView from "shared/RestrictedView";
import { USER_PERMISSIONS } from "dyl-components";

const TimelineContainer = ({ root }) => {
    const { state, pathname } = useLocation();
    const [isAddModalOpen, setIsAddModalOpen] = useState(state?.fromEmail || false);
    const record_type = pathname.split('/')[1];
    const isContact = record_type === 'contact';
    const dispatch = useDispatch();
    const [params] = useSearchParams();
    const { contact_id, account_id } = useParams();
    const record_id = contact_id || account_id;
    const { hasEmail, hasPhone } = useSelector((state) => {
        const email = root === "account" ? state?.account?.account?.emails : state?.contact?.email;
        const phone = root === "account" ? state?.account?.account?.phones : state?.contact?.phone;
        return {
            hasPhone: phone?.some?.(
                (p) => p?.phone && p?.phone?.trim?.().length > 0,
            ),
            hasEmail: email?.some?.(
                (e) => e?.email && e?.email?.trim?.()?.length > 0,
            ),
        }

    });
    
    const timelineApi =
            root === "account"
                ? timelineActions.accountTimelineTab
                : timelineActions.contactTimelineTab;

    const onToggleAddForm = () => {
        setIsAddModalOpen(true);
    };

    return (
        <React.Fragment>
        <Header className="ActivitiesTab__Header" as="h2">
            <ActivityPopup
                trigger={
                    <RestrictedView type="disabled" userPermission={root === "account" ? USER_PERMISSIONS.ACCOUNT_ADD : USER_PERMISSIONS.CONTACTS_ADD}>
                        <Icon
                            className="TimelineTab__add"
                            name="plus"
                            color="blue"
                            link
                            circular
                            inverted
                            size="tiny"
                            onClick={onToggleAddForm}
                            disabled={Boolean(!hasPhone && !hasEmail)}
                        />
                    </RestrictedView>
                }
                activityProps={{
                    readTimeline: () => { },
                    fromEmail: state?.fromEmail,
                    isContact: isContact
                }}
                open={isAddModalOpen}
                onOpen={() => setIsAddModalOpen(true)}
                onClose={(refetch) => {
                    setIsAddModalOpen(false);
                    if (refetch) {
                        dispatch(timelineApi(record_id, params));
                    }
                }}
            />
            Timeline
        </Header>
        <CallLogWrapper root={root} />
        </React.Fragment>
    );

};

export default TimelineContainer;
